import React, { Component } from 'react';
import mouse from '../../assets/images/icons/mouse-icn.svg';
import i18next from 'i18next';
class Mouse extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <>
                <div
                    className={`mouse-container ${
                        i18next.language === 'en' ? 'abs-right ml-5' : ''
                    }`}
                >
                    <div
                        className={`${
                            this.props.purple ? 'purple' : ''
                        } vertical-line`}
                    >
                        <div
                            className={`${
                                this.props.blue || this.props.purple
                                    ? 'blue-line'
                                    : ''
                            } ${this.props.white ? 'purple-line' : ''}`}
                        ></div>
                        <div
                            className={`${
                                this.props.white ? 'grey-line' : 'white-line'
                            }`}
                        ></div>
                    </div>
                    <img
                        src={mouse}
                        alt='mouse'
                        className={`mouse-img ${
                            i18next.language === 'en' ? 'en-mouse' : ''
                        }`}
                    />
                    <p
                        className={` ${
                            this.props.index === 0 && i18next.language === 'ar' ? '' : 'other-pages'
                        } first-page page-name ${
                            i18next.language === 'en' ? 'en-page-title' : ''
                        }`}
                    >
                        {i18next.language === 'ar'
                            ? `${this.props.ar_name}`
                            : `${this.props.en_name}`}
                    </p>
                </div>
            </>
        );
    }
}

export default Mouse;
